module.exports = __webpack_public_path__ + "static/clothing-jeans-6003a34e8461b59bc948c84c4da448df.jpg";